<template>
<v-btn icon @click="changeMute('not')">
  <v-icon v-if="mute">volume_mute</v-icon>
  <v-icon v-else>volume_up</v-icon>
</v-btn>
</template>

<script>
export default {
  methods: {
    changeMute () {
      this.$store.commit('toggle_mute');
    }
  },
  computed: {
    mute (v){
      return this.$store.getters.getmuted;
    }
  }
}
</script>


